import { InnoveraIcon } from "@libs/zapi-ui/assets";
import { Link, useParams, useLocation } from "react-router-dom";
import { getRouteProjects } from "@/zapi-frontend/shared/const/router";
import { OrganizationPicker } from "@/zapi-frontend/widgets/Header/ui/_OrganizationPicker";
import { HeaderLogo } from "./_HeaderLogo";
import { NotificationTrigger } from "@/zapi-frontend/features/Notifications";
import { FigmaTypography } from "@libs/zapi-ui/custom";
import { cn } from "@/zapi-frontend/shared/lib/utils";
import { useTranslation } from "react-i18next";

export function AppHeader() {
  const { t } = useTranslation("projects");
  const { id } = useParams();
  const { pathname } = useLocation();
  const showPortfolioTitle = pathname === "/";

  return (
    <div className={cn("w-full h-full flex items-center", showPortfolioTitle ? "gap-0" : "gap-4")}>
      {showPortfolioTitle ? (
        <>
          <HeaderLogo />
          <FigmaTypography variant="heading-3" color="zinc900" className="shrink-0 whitespace-nowrap px-3">
            {t("sidebar.projects")}
          </FigmaTypography>
        </>
      ) : (
        <Link
          data-testid="header-logo-link"
          to={getRouteProjects()}
          className="w-10 h-10 inline-flex justify-center items-center [&_svg>path]:hover:fill-innoveraOrange-400 [&_svg>path]:transition-[fill] [&_svg>path]:duration-[3ms]"
        >
          <InnoveraIcon className="w-6 h-6" />
        </Link>
      )}

      <div className="w-full h-full flex items-center justify-end">
        <div className="flex items-center gap-2">
          <OrganizationPicker />
          <NotificationTrigger projectId={id ? parseInt(id) : undefined} />
          <div className="w-[1px] h-3 bg-innoveraZinc-200 ml-2" />
        </div>
      </div>
    </div>
  );
}
